import UnicornApp from '../app';
export default class UnicornUri {
    app;
    static is = 'uri';
    asset = {
        path: (path) => '',
        root: (path) => '',
    };
    static install(app) {
        const $uri = app.$uri = new this(app);
        $uri.asset.path = (path = '') => {
            return app.asset('path') + path;
        };
        $uri.asset.root = (path = '') => {
            return app.asset('root') + path;
        };
    }
    constructor(app) {
        this.app = app;
        //
    }
    path(path = '') {
        return this.app.uri('path') + path;
    }
    root(path = '') {
        return this.app.uri('root') + path;
    }
    current() {
        return this.app.uri('current') || '';
    }
    full() {
        return this.app.uri('full') || '';
    }
    route() {
        return this.app.uri('route') || '';
    }
    script() {
        return this.app.uri('script') || '';
    }
}
